import { ApiRoutes } from "../../../../../constants/api";
import { BaseAPI, RequestMethod } from "../../../base";
import { DistrictRequestBody, DistrictResponse } from "./types";

export class DistrictAPI extends BaseAPI<
    DistrictRequestBody,
    DistrictResponse
> {
    protected route = ApiRoutes.search.district;
    protected method = RequestMethod.GET;
    protected params = ["city_id"];
} 